import React from "react";

const ComparisonCard = ({
  platformName,
  price,
  extraFees,
  earnings,
  happyEmoji,
  neutralEmoji,
  sadEmoji,
  isFirstItem,
  otherExtraFees,
}) => {
  const formatPrice = (price) => {
    return price.toLocaleString();
  };

  const getEmoji = () => {
    if (happyEmoji) return "😊";
    if (neutralEmoji) return "😐";
    if (sadEmoji) return "😟";
    return "";
  };

  const calculateSavingsRange = () => {
    if (otherExtraFees.length > 0) {
      const min = Math.min(...otherExtraFees);
      const max = Math.max(...otherExtraFees);
      return `You save ₹${formatPrice(min)} - ₹${formatPrice(max)}`;
    }
    return "";
  };

  return (
    <div className="flex flex-col items-start justify-start  bg-white border border-grey-5 rounded-2xl shadow-md w-[280px] p-10 gap-4">
      <div className="text-lg font-medium">{platformName}</div>
      <div>
        <div className="text-grey-70">You earn</div>
        <div className={`mt-2 text-2xl font-bold ${isFirstItem ? "text-primary-green" : "text-error"}`}>
          ₹ {formatPrice(earnings)} {getEmoji()}
        </div>
        {isFirstItem ? (
          <div className=" mt-4 p-2 bg-[#009D641A] text-primary-green rounded-md label-14">
            {calculateSavingsRange()}
          </div>
        ) : (
          <div className=" mt-4 p-2 bg-[#D92D201A] text-error rounded-md label-14">
            ₹ {formatPrice(extraFees)} extra in fees
          </div>
        )}
      </div>
    </div>
  );
};

export default ComparisonCard;
